import { Fragment } from 'react';

/**
 * A formatted figure that may wrap only after a thousands separator, so
 * a long amount drops whole digit groups to the next line instead of splitting
 * one. The span keeps it a single item inside a flex row.
 */
export function FigureText({ children }: { children: string }) {
  // A separator followed by exactly three digits groups thousands; any other one is
  // the decimal separator, and its cents stay on the line of their figure.
  const parts = children.split(/(?<=[.,])(?=\d{3}(?!\d))/);
  return (
    <span className="min-w-0">
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 && <wbr />}
          {part}
        </Fragment>
      ))}
    </span>
  );
}
